import { render, staticRenderFns } from "./BookingsEdit.vue?vue&type=template&id=2728a33b&"
import script from "./BookingsEdit.vue?vue&type=script&lang=js&"
export * from "./BookingsEdit.vue?vue&type=script&lang=js&"
import style0 from "./BookingsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports